var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hamburger",class:{
    'hamburger--active': _vm.active
  }},[_c('span',{staticClass:"hamburger-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }